import {
  Dialog,
  DialogHeader,
  DialogActions,
  Button,
} from '@frontend/ui-library';

export interface GetRefundModalProps {
  loading: boolean;
  isOffRamp: boolean;
  onGetRefundClick: () => void;
  onRequestClose: () => void;
}

export default function GetRefundModal({
  loading: refundLoading,
  isOffRamp,
  onGetRefundClick,
  onRequestClose,
}: GetRefundModalProps): JSX.Element {
  const description = isOffRamp
    ? 'This will cancel your current off ramp and initiate a refund process. You can still go back and refresh your exchange rate to continue.'
    : 'This will cancel your current order and initiate a refund process. You can still go back and refresh your exchange rate to continue with your purchase.';

  return (
    <Dialog onRequestClose={onRequestClose}>
      <DialogHeader description={description}>Get a refund?</DialogHeader>
      <DialogActions>
        <Button
          onClick={onRequestClose}
          size="medium"
          type="button"
          variant="secondary"
        >
          Go Back
        </Button>
        <Button
          size="medium"
          type="button"
          variant="danger"
          loading={refundLoading}
          onClick={onGetRefundClick}
        >
          get a refund
        </Button>
      </DialogActions>
    </Dialog>
  );
}
